// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0Q3xu","currency_wrapper":"styles_currency_wrapper__Qlarl","amount":"styles_amount__AV9I3"};